<div class="right-panel h-100 d-flex flex-column" style="overflow: auto">
  <!--Search bar-->
  <div class="d-flex">
    <input type="text" title="Search by Section or Name" placeholder="Search By Section/Name" class="search"
      [formControl]="searchTerm">
    @if (isMonitor == false) {
    <button type="button" class="actionBtn" (click)="uploadTemplateFile()" placement="top auto" container="body"
      triggers="hover" ngbTooltip="Upload RDP Or VNC Template">
      <span class="bi bi-upload"></span>
    </button>
    <div class="newDir h-100" ngbDropdown container="body" triggers="hover" ngbTooltip="Update Actions">
      <button type="button" class="actionBtn"  ngbDropdownToggle>
        <i class="bi bi-pencil-square"></i>
      </button>
      <div ngbDropdownMenu>
        <button *ngIf="isMonitor == false" ngbDropdownItem title="Update credentials" class="text-grey" (click)=" onUpdateCredentials()">
          Update Credentials
        </button>
        <button *ngIf="isMonitor == false" ngbDropdownItem title="Update Deployment Name" class="text-grey" (click)="changeDeploymentName()">
          Update Deployment Name
        </button>
        <button *ngIf="isMonitor == false && isCloudConnectorEnabled" ngbDropdownItem title="Update Cloud Connector" class="text-grey" (click)="updateInfraCred()">
          Update Connector
        </button>
      </div>
    </div>
    <!-- <div class="newDir h-100" ngbDropdown container="body" triggers="hover" ngbTooltip="Node Group Actions">
      <button type="button" class="actionBtn"ngbDropdownToggle>
        <i class="bi bi-gear"></i>
      </button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem title="Create node group" class="text-grey" (click)="createNodeGroup()">
          Create
        </button>
        <button ngbDropdownItem title="Update node group" class="text-grey" (click)="updateNodeGroup()">
          Update
        </button>
        <button ngbDropdownItem title="Delete node group" class="text-grey" (click)="deleteNodeGroup()">
          Delete
        </button>
      </div>
    </div> -->
    }
  </div>

  <!--setting panel-->
  <!-- <div class="settingsPanel">
    <ng-container *ngIf="configParameters">
      <app-config-section #configComp [configEntities]="configParameters"></app-config-section>
    </ng-container>
  </div> -->

  <div class="settingsPanel">
    <div class="section-container">
      <!-- <div>
        <input type="text" [formControl]="search">
      </div> -->
      <form action="" [formGroup]="depSettingForm">
        <div class="left ps-0">
          <div class="section" *ngFor="let section of evenSections">
            <div class="section-title">
              <h2 for="">{{ section[0] }}</h2>
            </div>
            <div class="section-body">
              <div *ngFor="let item of section[1]" class="body">
                <label for="">{{ getDisplayName(item.parameterName) }}</label>
                <input name="" *ngIf="item?.parameterTypeBoolean != 'true'" type="text" [title]="item.parameterValue"
                  [formControlName]="item.parameterName" />
                <select name="{{ item.parameterName }}" id="" formControlName="{{ item.parameterName }}"
                  *ngIf="item?.parameterTypeBoolean == 'true'">
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
                <span *ngIf="item.parameterDescription" class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                  placement="bottom" container="body"
                  [ngStyle]="{ 'margin-left': item?.parameterName.includes('Password') ? '0.65rem' : '0.3rem' }"
                  triggers="hover" [ngbTooltip]="syncHpcTooltips"></span>
                <ng-template #syncHpcTooltips>
                  <p>{{ item.parameterDescription }}</p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="section" *ngFor="let section of oddSections">
            <div class="section-title">
              <h2 for="">{{ section[0] }}</h2>
            </div>
            <div class="section-body">
              <div *ngFor="let item of section[1]" class="body">
                <label for="">{{ getDisplayName(item.parameterName) }}</label>
                <input name="" *ngIf="item?.parameterTypeBoolean != 'true'" [type]="text" [title]="item.parameterValue"
                  [formControlName]="item.parameterName" />
                <select name="{{ item.parameterName }}" id="" formControlName="{{ item.parameterName }}"
                  *ngIf="item?.parameterTypeBoolean == 'true'">
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
                <span *ngIf="item.parameterDescription" class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                  placement="bottom-right" container="body"
                  [ngStyle]="{ 'margin-left': item?.parameterName.includes('Password') ? '0.65rem' : '0.3rem' }"
                  triggers="hover" [ngbTooltip]="syncHpcTooltips"></span>
                <ng-template #syncHpcTooltips>
                  <p>{{ item.parameterDescription }}</p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Buttons -->
    <!-- <div class="settingRow" *ngIf="configParameters && isMonitor == false">
        <span class="settingTitle">Upload RDP Or VNC Template : </span>
        <button class="default-btn" (click)="uploadTemplateFile()">
          <span class="bi bi-pencil-square"></span> &nbsp;Upload Template File
        </button>
      </div>
      <div class="settingRow" *ngIf="configParameters && isMonitor == false && isVdiDep == false">
        <span class="settingTitle">Node Group : </span>
        <button class="default-btn" (click)="createNodeGroup()" title="Create new node group (or partition)">
          <span class="bi bi-pencil-square"></span> &nbsp;Create
        </button>
        <button class="default-btn" (click)="updateNodeGroup()" title="Update existing node group (or partition) properties" style="margin-left: 0.2%">
          <span class="bi bi-pencil-square"></span> &nbsp;Update
        </button>
        <button class="default-btn" (click)="deleteNodeGroup()" title="Delete existing node group (or partition)" style="margin-left: 0.2%">
          <span class="bi bi-trash"></span> &nbsp;Delete
        </button>
      </div> -->

    <!-- <div class="bottom-panel">
      <div class="first" *ngIf="currentEntity == 'Configurator'" style="flex: 1">
        <button (click)="redirectTo()" class="backBtn">
          <span class="bi bi-arrow-left" aria-hidden="True"></span>Back
        </button>
      </div>
      <button *ngIf="isMonitor == false" class="saveBtn" (click)="onSave(depSettingForm)">
        <span class="bi bi-save" aria-hidden="True" style="margin-right: 10px"></span>Save
      </button>
    </div> -->
    <div class="bottom-panel">
      @if (isMonitor == false) {
        @if (currentEntity == 'Configurator') {
          <button (click)="redirectTo()" class="default-btn">
            <span class="bi bi-arrow-left" aria-hidden="True"></span>Back
          </button>
        }
        <button class="default-btn" (click)="onSave(depSettingForm)">
          <span class="bi bi-save" aria-hidden="True" style="margin-right: 10px"></span>Save
        </button>
      }
  </div>


  <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
    [fullScreen]="false">
    <p>Please wait ...</p>
  </ngx-spinner>
